<template>
<v-app style="background-color:white">
    <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    <v-card class="form-container" flat style="margin-top:-10px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-container class="purchase-container" style="background-color:white">
          <v-layout row wrap>
            <v-flex xs6>
              <!-- SELECTING VENDOR AND GET VENDOR DATA -->
              <v-autocomplete
                v-model="selectedVendor"
                :items="Vendors"
                label="Select vendor"
                item-text="VendorName"
                item-value="id"
                persistent-hint
                return-object
                single-line
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6>
              <!-- IF VENDOR SELECTED THEN -> FETCH VENDOR GST NUMBER -->
              <div v-if="selectedVendor">
                <v-text-field disabled v-model="selectedVendor.GstNumber" label="GST number"></v-text-field>
              </div>
              <!-- IF VENDOR NOT SELECTED THEN -> ONLY SHOWING THE TEXT FIELD -->
              <div v-if="!selectedVendor">
                <v-text-field disabled label="GST number"></v-text-field>
              </div>
            </v-flex>
            <v-flex xs4>
              <!-- PURCHASE DATE -->
              <v-dialog
                ref="dialog"
                v-model="purchaseDateModel"
                persistent
                lazy
                full-width
                width="290px"
              >
                <v-text-field
                  append-icon="event"
                  slot="activator"
                  v-model="form.purchaseDate"
                  label="Date"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="form.purchaseDate" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="purchaseDateModel = false">ok</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <!-- DUE DATE -->
            <v-flex xs4>
              <v-dialog
                ref="dialog"
                v-model="dueDateModel"
                persistent
                lazy
                full-width
                width="290px"
              >
                <v-text-field
                  append-icon="event"
                  slot="activator"
                  v-model="form.dueDate"
                  label="Due date"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="form.dueDate" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="dueDateModel = false">ok</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <!-- SHIP DATE -->
            <v-flex xs4>
              <v-dialog
                ref="dialog"
                v-model="shipDateModel"
                persistent
                lazy
                full-width
                width="290px"
              >
                <v-text-field
                  append-icon="event"
                  slot="activator"
                  v-model="form.shipDate"
                  label="Req. ship date"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="form.shipDate" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="shipDateModel = false">ok</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <!-- ITEM SELECTION -->
            <!-- Item selection will show if vendor was selected , els it will not show -->
            <v-flex xs12 v-if="selectedVendor">
              <v-toolbar flat color="transparent">
                <v-toolbar-title class="grey--text">Item selection</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <!-- Here is a dialog i'm activating when ADD NEW button will click -->
                <v-dialog v-model="dialog" max-width="500px" persistent>
                  <v-btn color="primary" depressed slot="activator">Add new</v-btn>
                  <v-card style="border-radius: 10px">
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12>
                            <!-- You have to select one of the item from api end point -> "http://supremoapi.infosyst.in/api/Items" -->
                            <!-- i sugest selecting TEST FOR DEVELOPMENT Item  -->
                            <v-autocomplete
                              dense
                              v-model="selectItem"
                              :items="Items"
                              label="Select item"
                              item-text="ItemName"
                              item-value="id"
                              persistent-hint
                              return-object
                              single-line
                            ></v-autocomplete>
                            <!-- after selecting any item the item value's will stor in a model called *selectItem* -->
                            <!-- now *selectItem* storing that selected item value , so now we can also show it in to text field -->
                            <div v-if="selectItem">
                              <v-text-field disabled label="HSN rate" v-model="selectItem.HsnRate"></v-text-field>
                              <v-text-field label="Qty" v-model="editedItem.qty"></v-text-field>
                              <v-text-field disabled label="Unit" v-model="selectItem.UomName"></v-text-field>
                              <v-text-field
                                disabled
                                label="Unit Price"
                                v-model="selectItem.PurchaseRate"
                              ></v-text-field>
                            </div>
                            <div v-if="selectItem" style="font-family: roboto mono;font-size:12px" class="row">
                              
                              <div class="col-lg-12 col-md-12 col-sm-12">
                                <p>TAXABLE VALUE : {{ (selectItem.PurchaseRate * editedItem.qty) }}</p>
                              </div>
                              
                              
                              <div class="col-lg-4 col-md-4 col-sm-12">
                                <!-- CGST -->
                              <span v-if="companyStateCode == selectedVendor.BillingStateCode">
                                <p>CGST : {{ ((selectItem.PurchaseRate * editedItem.qty) * selectItem.HsnRate) /100 /2 }}</p>
                              </span>
                              <span v-if="companyStateCode != selectedVendor.BillingStateCode">
                                <p>CGST : 0</p>
                              </span>
                              </div>

                              <div class="col-lg-4 col-md-4 col-sm-12">
                                <!-- SGST -->
                              <span v-if="companyStateCode == selectedVendor.BillingStateCode">
                                <p>SGST : {{ ((selectItem.PurchaseRate * editedItem.qty) * selectItem.HsnRate) /100 /2 }}</p>
                              </span>
                              <span v-if="companyStateCode != selectedVendor.BillingStateCode">
                                <p>SGST : 0</p>
                              </span>
                              </div>

                              <div class="col-lg-4 col-md-4 col-sm-12">
                                <!-- IGST -->
                              <span v-if="companyStateCode != selectedVendor.BillingStateCode">
                                <p>IGST : {{ ((selectItem.PurchaseRate * editedItem.qty) * selectItem.HsnRate) /100 }}</p>
                              </span>
                              <span v-if="companyStateCode == selectedVendor.BillingStateCode">
                                <p>IGST : 0</p>
                              </span>
                              </div>
                              
                              
                            </div>
                          </v-flex>
                          <v-flex xs12 style="text-align:right">
                            <v-btn color="error" flat @click="close()">Cancel</v-btn>
                            <v-btn color="success" flat @click="save()">Save</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-toolbar>
              <v-data-table :headers="headers" :items="itemAdded" hide-actions>
                <template slot="items" slot-scope="props">
                  <td class="text-xs-left">{{ props.item.item }}</td>
                  <td class="text-xs-left">{{ props.item.qty }}</td>
                  <td class="text-xs-left">{{ props.item.uomName }}</td>
                  <td class="text-xs-left">{{ props.item.purchaseRate }}</td>
                  <td class="text-xs-left">{{ props.item.taxableAmount }}</td>
                  <td class="text-xs-left">{{ props.item.cgst }}</td>
                  <td class="text-xs-left">{{ props.item.sgst }}</td>
                  <td class="text-xs-left">{{ props.item.igst }}</td>
                  <td class="justify-center layout px-0">
                    <v-icon color="error" small @click="deleteItem(props.item)">delete</v-icon>
                  </td>
                </template>
              </v-data-table>
              <!-- TOTAL ALL -->
              <v-flex xs12 v-if="itemAdded" class="mt-4">
                <v-toolbar flat color="transparent">
                  <v-toolbar-title class="info--text">Total calculation</v-toolbar-title>
                </v-toolbar>
                <div class="ml-4" style="font-family: roboto mono">
                  <v-chip label color="blue-grey " text-color="white">
                    <v-icon left>assessment</v-icon>
                    Taxable amount: {{Math.round(taxableAmount * 100) / 100}}
                  </v-chip>
                  <br>
                  <v-chip label color="blue-grey " text-color="white">
                    <v-icon left>description</v-icon>
                    CGST: {{cgstTotal}}
                  </v-chip>
                  <v-chip label color="blue-grey " text-color="white">
                    <v-icon left>description</v-icon>
                    SGST: {{sgstTotal}}
                  </v-chip>
                  <v-chip label color="blue-grey " text-color="white">
                    <v-icon left>description</v-icon>
                    IGST: {{igstTotal}}
                  </v-chip>
                  <v-chip label color="blue-grey " text-color="white">
                    <v-icon left>description</v-icon>
                    GST: {{cgstTotal + sgstTotal + igstTotal}}
                  </v-chip>
                  <br>
                  <v-chip label color="blue-grey darken-3" text-color="white">
                    <v-icon left>swap_vertical_circle</v-icon>
                    Total amount after tax: {{Math.round((taxableAmount + cgstTotal + sgstTotal + igstTotal) * 100) / 100}}
                  </v-chip>
                </div>
              </v-flex>
            </v-flex>
            <v-flex xs12 sm12 md12 style="text-align:right">
            <v-btn depressed color="#e53935" dark @click="back()">Cancel</v-btn>
            <v-btn depressed :loading="btnSave" color="primary" dark @click="onSubmit()">Save </v-btn>
          </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn flat @click="snack = false">Close</v-btn>
    </v-snackbar>
 
</v-app>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
      dialog: false,
      snack: false,
      btnSave: false,
      snackColor: "",
      snackText: "",
      qtyRule: v => v.length > 0 || "Qty should be one at least!",
      title: "Create purchase order",
      purchaseDateModel: null,
      dueDateModel: null,
      shipDateModel: null,

      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "Purchase Order",
          disabled: false,
          to: "/purchaseOrder"
        },
        {
          text: "Create",
          disabled: true,
          to: "/createStudent"
        }
      ],

      itemAdded: [],
      selectItem: null,

      editedIndex: -1,
      editedItem: {
        item: null,
        hsnCode: null,
        qty: 1,
        uomName: null,
        purchaseRate: 0,
        total: 0,
        discount: 0,
        taxableValue: 0,
        cGst: 0,
        sGst: 0,
        iGst: 0
      },
      defaultItem: {
        item: null,
        hsnCode: null,
        qty: 1,
        uomName: null,
        purchaseRate: 0,
        total: 0,
        discount: 0,
        taxableValue: 0,
        cGst: 0,
        sGst: 0,
        iGst: 0
      },

      headers: [
        { text: "Select item", value: "item" },
        { text: "Qty", value: "qty", sortable: false },
        { text: "Unit", value: "uomName" },
        { text: "Unit price", value: "purchaseRate" },
        { text: "Taxable amount", value: "taxableAmount" },
        { text: "CGST", value: "cgst" },
        { text: "SGST", value: "sgst" },
        { text: "IGST", value: "igst" },
        { text: "Remove", value: "Remove" }
      ],
      valid: false,
      selectedVendor: null,
      form: {
        purchaseDate: new Date().toISOString().substr(0, 10),
        dueDate: new Date().toISOString().substr(0, 10),
        shipDate: new Date().toISOString().substr(0, 10)
      },
      Vendors: [],
      Items: [],
      companyStateCode: null,
      inputRules: [v => !!v || "This is empty !!"]
    };
  },

  mounted() {
    this.$Progress.start();
    // vendors
    this.axios
      .get(config.API + "Vendors1", { headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              } })
      .then(response => {
        this.Vendors = response.data;
      });

    // items
    this.axios
      .get(config.API + "Products1", { headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              } })
      .then(response => {
        this.Items = response.data;
      });
    // Companies
    this.axios
      .get(config.API + "Companies", { headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              } })
      .then(response => {
        this.companyStateCode = response.data[0].billingStateCode;
        this.$Progress.finish();
      });
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },

    cgstTotal: function() {
      let total = [];
      Object.entries(this.itemAdded).forEach(([key, val]) => {
        total.push(val.cgst); // the value of the current key.
      });
      return total.reduce(function(total, num) {
        return total + num;
      }, 0);
    },
    sgstTotal: function() {
      let total = [];
      Object.entries(this.itemAdded).forEach(([key, val]) => {
        total.push(val.sgst); // the value of the current key.
      });
      return total.reduce(function(total, num) {
        return total + num;
      }, 0);
    },
    igstTotal: function() {
      let total = [];
      Object.entries(this.itemAdded).forEach(([key, val]) => {
        total.push(val.igst); // the value of the current key.
      });
      return total.reduce(function(total, num) {
        return total + num;
      }, 0);
    },
    taxableAmount: function() {
      let total = [];
      Object.entries(this.itemAdded).forEach(([key, val]) => {
        total.push(val.taxableAmount); // the value of the current key.
      });
      return total.reduce(function(total, num) {
        return total + num;
      }, 0);
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  methods: {
    editItem(item) {
      this.editedIndex = this.itemAdded.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.itemAdded.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.itemAdded.splice(index, 1);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.selectItem = null;
      }, 300);
    },

    save() {
      /* if (this.editedIndex > -1) { */
      let lth = this.itemAdded.length;

      if (lth == 0) {
        if (this.companyStateCode == this.selectedVendor.BillingStateCode) {
          this.itemAdded.push({
            item: this.selectItem.ItemName,
            productId: this.selectItem.Id,
            hsnCode: this.selectItem.Code,
            hsnRate: this.selectItem.HsnRate,
            qty: JSON.parse(this.editedItem.qty),
            uomName: this.selectItem.UomName,
            purchaseRate: this.selectItem.PurchaseRate,
            taxableAmount: this.selectItem.PurchaseRate * this.editedItem.qty,
            cgst:
              ((this.selectItem.PurchaseRate * this.editedItem.qty) * this.selectItem.HsnRate) /
               100 / 2,
            cgstRate: this.selectItem.HsnRate / 2,
            sgst:
              ((this.selectItem.PurchaseRate * this.editedItem.qty) * this.selectItem.HsnRate) /
               100 / 2,
            sgstRate: this.selectItem.HsnRate / 2,
            igst: 0,
            igstRate: 0
          });
        } else {
          this.itemAdded.push({
            item: this.selectItem.ItemName,
            productId: this.selectItem.Id,
            hsnCode: this.selectItem.Code,
            hsnRate: this.selectItem.HsnRate,
            qty: JSON.parse(this.editedItem.qty),
            uomName: this.selectItem.UomName,
            purchaseRate: this.selectItem.PurchaseRate,
            taxableAmount: this.selectItem.PurchaseRate * this.editedItem.qty,
            cgst: 0,
            cgstRate: 0,
            sgst: 0,
            sgstRate: 0,
            igst:
              ((this.selectItem.PurchaseRate * this.editedItem.qty) * this.selectItem.HsnRate) / 100,
            igstRate: this.selectItem.HsnRate
          });
        }

        this.close();
      }
      else {
        let flag = '';

        for(let i = 0; i < lth; i++) {
          let item_id = this.itemAdded[i].productId;

          if (item_id == this.selectItem.Id) {
            flag = true;
          }
        }

        if (flag == true) {
            this.$toaster.error(`Already Taken!!`);
          }
          else
          {
             if (this.companyStateCode == this.selectedVendor.BillingStateCode) {
          this.itemAdded.push({
            item: this.selectItem.ItemName,
            productId: this.selectItem.Id,
            hsnCode: this.selectItem.Code,
            hsnRate: this.selectItem.HsnRate,
            qty: JSON.parse(this.editedItem.qty),
            uomName: this.selectItem.UomName,
            purchaseRate: this.selectItem.PurchaseRate,
            taxableAmount: this.selectItem.PurchaseRate * this.editedItem.qty,
            cgst:
              ((this.selectItem.PurchaseRate * this.editedItem.qty) * this.selectItem.HsnRate) /
               100 / 2,
            cgstRate: this.selectItem.HsnRate / 2,
            sgst:
              ((this.selectItem.PurchaseRate * this.editedItem.qty) * this.selectItem.HsnRate) /
               100 / 2,
            sgstRate: this.selectItem.HsnRate / 2,
            igst: 0,
            igstRate: 0
          });
        } else {
          this.itemAdded.push({
            item: this.selectItem.ItemName,
            productId: this.selectItem.Id,
            hsnCode: this.selectItem.Code,
            hsnRate: this.selectItem.HsnRate,
            qty: JSON.parse(this.editedItem.qty),
            uomName: this.selectItem.UomName,
            purchaseRate: this.selectItem.PurchaseRate,
            taxableAmount: this.selectItem.PurchaseRate * this.editedItem.qty,
            cgst: 0,
            cgstRate: 0,
            sgst: 0,
            sgstRate: 0,
            igst:
              ((this.selectItem.PurchaseRate * this.editedItem.qty) * this.selectItem.HsnRate) / 100,
            igstRate: this.selectItem.HsnRate
          });
        }
        this.close();
          }
      }
    },

    onSubmit() {
      /* console.log(
        {
            vendorId: this.selectedVendor.Id,
            purchaseDate: this.form.purchaseDate,
            dueDate: this.form.dueDate,
            shipDate: this.form.shipDate,
            taxableAmount: Math.round(this.taxableAmount * 100) / 100,
            cgst: this.cgstTotal,
            sgst: this.sgstTotal,
            igst: this.igstTotal,
            gst: this.cgstTotal + this.sgstTotal + this.igstTotal,
            totalAfterTax:
              Math.round(
                (this.taxableAmount +
                  this.cgstTotal +
                  this.sgstTotal +
                  this.igstTotal) *
                  100
              ) / 100,
            purchaseOrderDetails: this.itemAdded
          }
      ); */
      this.btnSave = true;
      this.axios
        .post(
          config.API + "PurchaseOrders",
          {
            vendorId: this.selectedVendor.Id,
            purchaseDate: this.form.purchaseDate,
            dueDate: this.form.dueDate,
            shipDate: this.form.shipDate,
            taxableAmount: Math.round(this.taxableAmount * 100) / 100,
            cgst: this.cgstTotal,
            sgst: this.sgstTotal,
            igst: this.igstTotal,
            gst: this.cgstTotal + this.sgstTotal + this.igstTotal,
            totalAfterTax:
              Math.round(
                (this.taxableAmount +
                  this.cgstTotal +
                  this.sgstTotal +
                  this.igstTotal) *
                  100
              ) / 100,
            purchaseOrderDetails: this.itemAdded
          },
          {
            headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
          }
        )
        .then(res => {
          this.$toaster.success("Successfully added");
            //this.$router.push(`counsellingImage/${code}`);
            this.$router.go(-1);
        })
        .catch(err => {
          this.$toaster.error(err.message);
          this.btnSave = false;
        });
    }
  }
};
</script>